var ezdia;
(function (ezdia) {
    function alertDetails(backUrl, alertData) {
        var htmlContent = "<div class=\"ez-callout ez-callout-warning\">Error fetching data. Please try again</div>";
        if (alertData) {
            htmlContent = "<div class=\"eza-alert-details\"> " + alertData
                .map(function (_a) {
                var label = _a.label, value = _a.value;
                return "<div class='notification-card'>\n            <div class='alert-label'>" + label + "</div>\n            <div class='alert-value'>" + value + "</div>\n          </div>";
            })
                .join('') + "</div>";
        }
        return "<div id=\"ez-alert-rule-navigation\" class=\"ez-alert-rule-navigation\">\n      <div class=\"ez-alerts-back\">\n        <a title=\"Back\" class=\"btn btn-default btn-circle\" href=\"" + backUrl + "\" >\n          <i class=\"fa ez-back-nav\"></i>\n        </a>\n      </div>\n      <div id=\"ez-alert-details-container\" class=\"ez-alert-details-container\">\n        " + htmlContent + " \n      </div>\n    </div>";
    }
    function browseByTabs(tabs) {
        return "<div class=\"text-center\">\n      <div class=\"btn-group-tab-wrapper\">\n        <div class=\"small text-muted\">Browse by</div>\n        <div class=\"btn-group btn-group-sm btn-group-tab\">\n          " + tabs
            .map(function (_a) {
            var label = _a.label, href = _a.href, active = _a.active;
            var cls = active ? 'active' : '';
            return "<a class=\"btn btn-default " + cls + "\" href=\"" + href + "\" >" + label + "</a>";
        })
            .join('') + "\n        </div>\n      </div>\n    </div>";
    }
    var templates;
    (function (templates) {
        templates.ezAnalytics = {
            browseByTabs: browseByTabs,
            alertDetails: alertDetails
        };
    })(templates = ezdia.templates || (ezdia.templates = {}));
})(ezdia || (ezdia = {}));
